export const ideaGettingStartedArticle = {
  title: 'Business Idea Generator: Getting Started',
  slug: 'idea-generator-getting-started',
  content: `Business Idea Generator: Getting Started

Generate tailored business ideas based on your skills, time, and market scope.

1) Open the generator
- Go to /idea-generator.
- The wizard opens automatically on first load.

2) Complete the wizard
- Choose skills and your level.
- Set time commitment and work environment.
- Pick market scope (local, national, or international).

3) Generate ideas
- Submit the wizard to generate a set of ideas.
- The results list shows each idea with summaries and metadata.

Tips
- Guests can generate one free idea per day.
- Sign up to save ideas and unlock related tools.
`,
};
